export default __webpack_public_path__ + "static/media/img_company_header34.72dd6541.png";